import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getDepartments, type Department } from "../api/departments";

export function useDepartments() {
  return useQuery({
    queryKey: ["departments"],
    queryFn: getDepartments,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

export function useDepartmentNames(): {
  names: string[];
  isLoading: boolean;
  departments: Department[];
} {
  const { data, isLoading } = useDepartments();
  const { names, departments } = useMemo(() => {
    const list = Array.isArray(data) ? data : [];
    const names = Array.from(
      new Set(
        list
          .map((d) => (typeof d === "string" ? d : d?.name))
          .filter((n): n is string => typeof n === "string" && n.length > 0),
      ),
    ).sort();
    return { names, departments: list };
  }, [data]);
  return { names, isLoading, departments };
}
